import { render, staticRenderFns } from "./CompanyDetailCard.vue?vue&type=template&id=37096d03&"
import script from "./CompanyDetailCard.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports